import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import { i18n } from "./setups/i18n"
import globalComponentsRegistration from "./setups/globalComponentsRegistration.js"
import directivesRegistration from "./setups/directivesRegistration.js"
import pluginsRegistration from "./setups/pluginsRegistration.js"
import themeRegistration from "./setups/themeRegistration.js"
import "./assets/css/studioTailwind/index.css"
import "./assets/css/studioTailwind/animate.css"
import { initApp } from "./middlewares/initApp"

// Setup
themeRegistration()
globalComponentsRegistration()
directivesRegistration()
pluginsRegistration()

Vue.config.productionTip = false

const app = new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
})

initApp(app)

app.$mount("#app")
